
import { defineComponent } from 'vue';
import { authClient } from '@/apis';
import log from '@/utils/log';

export default defineComponent({
  data: () => ({
    email: '',
    emailSuffix: '@fudan.edu.cn',
    emailRules: [(v: string) => !!v || '邮箱不能为空', (v: string) => /^\d{11}$/.test(v) || '请输入11位学号'],
    code: '',

    password: '',
    passwordRules: [(v: string) => !!v || '密码不能为空'],
    password2: '',

    alertType: 'success',
    alertShown: false,
    alertContent: '',

    cooldownCnt: 0,
    state: 'init',
  }),
  computed: {
    realEmail(): string {
      return this.email.trim() + this.emailSuffix;
    },
  },
  methods: {
    resetPassword() {
      if (!/^\d{11}@fudan\.edu\.cn$/.test(this.realEmail)) {
        this.$message.warn('请输入11位学号邮箱');
        return;
      }
      if (!/^\d{6}$/.test(this.code)) {
        this.$message.warn('请输入六位数字的验证码');
        return;
      }
      if (this.password !== this.password2) {
        this.$message.warn('两次输入的密码不相等');
        return;
      }
      if (this.password === '') {
        this.$message.warn('密码不能为空');
        return;
      }
      if (this.password.length < 6) {
        this.$message.warn('密码长度至少为 6 个字符哦');
        return;
      }
      if (this.password.length > 32) {
        this.$message.warn('密码长度最多为 32 个字符哦');
        return;
      }
      authClient
        .resetPassword({
          email: this.realEmail,
          code: parseInt(this.code, 10),
          password: this.password,
        })
        .then(() => {
          this.$message.success('修改成功');
          setTimeout(() => this.$router.push('/login'), 500);
        })
        .catch((e) => {
          const code = e.response.status;
          if (code === 409) this.$message.error('验证码错误');
          else if (code === 404) this.$message.error('邮箱不存在');
          else if (code === 400) this.$message.error('格式不正确');
        });
    },
    requestCode() {
      if (this.state === 'init' || this.state === 'resend') {
        if (!/^\d{11}@fudan\.edu\.cn$/.test(this.realEmail)) {
          this.$message.warn('请输入11位学号邮箱');
          return;
        }

        this.state = 'requesting';

        authClient.requestCodeForForgotPassword({ email: this.realEmail })
          .then(() => {
            this.state = 'cooldown';
            this.cooldownCnt = 60;
            this.$message.success('验证码发送成功');
            const countdown = () => {
              this.cooldownCnt -= 1;
              if (this.cooldownCnt <= 0) this.state = 'resend';
              else if (this.state === 'cooldown') setTimeout(countdown, 1000);
            };
            setTimeout(() => countdown(), 1000);
          })
          .catch((e) => {
            this.state = 'init';
            log.error('send code failed', e);
          });
      } else if (this.state === 'cooldown' || this.state === 'requesting') {
        log.info('cooldown-ing or requesting');
      } else {
        log.info('Unexpected state');
      }
    },
  },
});
